import { ExtractionTool } from 'pages/ChooseYourTemplatePage/ChooseYourTemplatePage';
import { UPDATE_REVIEW_SETTINGS_ROUTE, tokenizeRoute } from 'query/routes';

type UpdateExtractionExperience = {
  reviewId: string;
  dataExtractionExperience: ExtractionTool;
};

export const updateExtractionExperience = async ({
  reviewId,
  dataExtractionExperience,
}: UpdateExtractionExperience) => {
  const url = tokenizeRoute(UPDATE_REVIEW_SETTINGS_ROUTE, {
    review_id: reviewId,
  });
  const body = {
    review_settings: {
      data_extraction_experience: dataExtractionExperience,
    },
  };

  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(body),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
